if (!customElements.get("image-with-text-slider")) {
  class imageWithTextSlider extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        contents: [".f-slider__content-wrapper"],
        textContainer: ".f-slider__text",
        mediaContainer: ".f-slider__media",
        pageDots: ".flickity-page-dots",
        pageCounter: ".flickity-page-counter",
      };
      this.domNodes = queryDomNodes(this.selectors, this);
      // this.deferInit = this.hasAttribute('data-defer-slider')
      // this.initialized = false
      // if (this.deferInit) {
      //   this.scheduleInit()
      // } else {
      //   this.init()
      // }
      this.deferInit = true;
      this.scheduleInit();
    }

    disconnectedCallback() {
      clearInterval(this.check);
    }

    scheduleInit() {
      const runInit = () => {
        if (!this.initialized) {
          this.init();
        }
      };

      if (typeof window.requestIdleCallback === "function") {
        requestIdleCallback(runInit, { timeout: 1000 });
      } else if (document.readyState === "complete" || document.readyState === "interactive") {
        runInit();
      } else {
        document.addEventListener("DOMContentLoaded", runInit, { once: true });
      }
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;

      // Flickity only initialises with more than one slide, so with a single slide there is
      // nothing to poll for - set the slide up statically instead of spinning forever.
      if (this.hasAttribute("data-single-slide")) {
        this.initStatic();
        return;
      }

      let attempts = 0;
      this.check = setInterval(() => {
        this.textSlider = this.domNodes.textContainer.slider && this.domNodes.textContainer.slider.instance;
        this.mediaSlider = this.domNodes.mediaContainer.slider && this.domNodes.mediaContainer.slider.instance;
        if (this.textSlider && typeof this.textSlider == "object") {
          clearInterval(this.check);
          this.removeAttribute("data-media-loading");
          this.textSlider.on("change", this.handleChange.bind(this));
          if (this.mediaSlider) {
            this.mediaSlider.on("change", (index) => {
              this.textSlider.select(index);
            });
          }
          this.handleScreenChange();
          this.applyLayout(this.domNodes.contents[this.textSlider.selectedIndex || 0]);
          this.playVideo();
          if (this.domNodes.pageCounter) {
            this.domNodes.textContainer.insertBefore(this.domNodes.pageCounter, null);
          }
        } else if (++attempts >= 50) {
          // 5s without a slider: it is never coming. Don't leak the interval, and don't
          // leave the section stuck in its loading state.
          clearInterval(this.check);
          this.initStatic();
        }
      }, 100);
    }

    // Render the first slide without a slider: no change events, no pagination.
    initStatic() {
      clearInterval(this.check);
      this.removeAttribute("data-media-loading");

      const firstContent = this.domNodes.contents[0];
      if (firstContent) {
        if (firstContent.dataset.colorScheme) {
          this.domNodes.textContainer.classList.add(firstContent.dataset.colorScheme);
        }
        this.applyLayout(firstContent);
      }

      this.handleScreenChange();
      this.playVideo();
    }

    handleChange(index) {
      const sliderCounterCurrent = this.querySelector(".flickity-counter--current");
      const slideContentCurrent = this.domNodes.contents[index];
      if (!slideContentCurrent) return;
      const currentColorScheme = slideContentCurrent.dataset.colorScheme;

      Array.from(this.domNodes.contents, (el) => {
        this.domNodes.textContainer.classList.remove(el.dataset.colorScheme);
      });

      this.domNodes.textContainer.classList.add(currentColorScheme);
      this.applyLayout(slideContentCurrent);

      // Handle page counter
      if (this.domNodes.pageCounter && sliderCounterCurrent) {
        sliderCounterCurrent.textContent = index + 1;
      }

      if (this.mediaSlider) {
        this.mediaSlider.select(index);
      }

      this.playVideo();
    }

    applyLayout(slideContentCurrent) {
      if (!slideContentCurrent) return;
      if (this.classList.contains("f-slider-wrapper--image-overlay")) return;

      const imagePosition = slideContentCurrent.dataset.imagePosition;
      if (imagePosition !== "left" && imagePosition !== "right") return;

      this.classList.toggle("is-image-left", imagePosition === "left");
      this.classList.toggle("is-image-right", imagePosition === "right");
    }

    playVideo() {
      this.pauseAllMedia();
      const selectedElm = (this.mediaSlider && this.mediaSlider.selectedElement) || this.domNodes.mediaContainer.querySelector(".f-slider__slide");
      if (!selectedElm) return;
      const deferredMedia = selectedElm.querySelector("deferred-media");

      if (deferredMedia) {
        deferredMedia.loadContent();
        const youtube = deferredMedia.querySelector(".js-youtube");
        const vimeo = deferredMedia.querySelector(".js-vimeo");
        const video = deferredMedia.querySelector("video");
        if (video) video.play();
        if (youtube) youtube.contentWindow.postMessage('{"event":"command","func":"' + "playVideo" + '","args":""}', "*");
        if (vimeo) vimeo.contentWindow.postMessage('{"method":"play"}', "*");
      }
    }

    pauseAllMedia() {
      this.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
      });
      this.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      this.querySelectorAll("video").forEach((video) => video.pause());
    }

    handleScreenChange() {
      if (FoxThemeSettings.isMobile) {
        // this.domNodes.flickity.toggleFade()
      }
      document.addEventListener("matchMobile", () => {
        // this.domNodes.flickity.toggleFade()
      });
      document.addEventListener("unmatchMobile", () => {
        // this.domNodes.flickity.toggleFade(true)
      });
    }
  }

  customElements.define("image-with-text-slider", imageWithTextSlider);
}
